import { useAppData } from "../../hooks/useAppData";
import "./notification.css";

export default function Notification() {
  const { isNotification, notificationText } = useAppData();

  return (
    <div id={!isNotification ? "hide" : ""} className="notification-container">
      <p>{notificationText}</p>
    </div>
  );
}
